module.exports = __webpack_public_path__ + "img/publicar-home-back-exotics.88770589.png";